<h1 mat-dialog-title>ACH Agreement</h1>
<div mat-dialog-content>
  <form [formGroup]="achAgreementForm">
    <h3>Please read and agree to the following ACH terms:</h3>
    <br />
    <h4>{{ achAgreementForm.get("agreement_terms")?.value }}</h4>

    <div class="authorizer-inputs">
      <mat-form-field class="full-width">
        <mat-label>Authorizer First Name</mat-label>
        <input matInput formControlName="authorizer_first_name" />
      </mat-form-field>

      <mat-form-field class="full-width">
        <mat-label>Authorizer Last Name</mat-label>
        <input matInput formControlName="authorizer_last_name" />
      </mat-form-field>
    </div>
  </form>
</div>
<div mat-dialog-actions class="actions">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-button (click)="onSubmit()" [disabled]="!achAgreementForm.valid">
    Agree
  </button>
</div>
